import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import app from './app';
import config from './config';

const rootReducer = combineReducers({
  app: persistReducer({
    key: 'ff',
    storage,
  }, app),
  config,
});

export default rootReducer;




// WEBPACK FOOTER //
// ./src/sub-projects/fusionfabric/reducers/index.ts